/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue';
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue';
import VxCard  from './components/vx-card/VxCard.vue';
import VsTabs from './components/vs-tabs/VsTabs';
import VsTab from './components/vs-tabs/VsTab';
import VxList  from './components/vx-list/VxList.vue';
import VsCustomButton from './components/vs-custom-button/VsCustomButton';
import VsPhone from './components/vs-phone/VsPhone';
import VsPassword from './components/vs-password/VsPassword';
import VsDatepicker from './components/vs-datepicker/VsDatepicker';
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue';
import FeatherIcon  from './components/FeatherIcon.vue';
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue';
import VsPagination  from './components/vs-pagination/VsPagination.vue';
import VsSimpleUpload  from './components/vs-simple-upload/VsSimpleUpload.vue';
import VsUpload from "./components/vs-upload/VsUpload";
import VsColor from  "./components/vs-color/VsColor";
import VsDropdown from "@/components/vs-dropdown/VsDropdown";
import VsDropdownMenu from "@/components/vs-dropdown/VsDropdownMenu";
import VsTable from './components/vs-table/VsTable';
import VsTr from './components/vs-table/VsTr';
import VsTh from './components/vs-table/VsTh';
import TextEditor from "@/components/text-editor/TextEditor.vue";

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VsTabs.name, VsTabs);
Vue.component(VsTab.name, VsTab);
Vue.component(VxList.name, VxList);
Vue.component(VsCustomButton.name, VsCustomButton);
Vue.component(VsPhone.name, VsPhone);
Vue.component(VsPassword.name, VsPassword);
Vue.component(VsDatepicker.name, VsDatepicker);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);
Vue.component(VsPagination.name, VsPagination);
Vue.component(VsUpload.name, VsUpload);
Vue.component(VsSimpleUpload.name, VsSimpleUpload);
Vue.component(VsColor.name, VsColor);
Vue.component(VsDropdown.name, VsDropdown);
Vue.component(VsDropdownMenu.name, VsDropdownMenu);
Vue.component(VsTable.name, VsTable);
Vue.component(VsTr.name, VsTr);
Vue.component(VsTh.name, VsTh);
Vue.component(TextEditor.name, TextEditor);


// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component(vSelect)
